import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CertificationListComponent } from '../admin/certification-list.component';
import { AccountAssessment } from '../../models/AssessmentModel';
import { ActivatedRoute, Router } from '@angular/router';
import { Account } from '../../models/AccountModel';
import { PlatformApiService } from 'src/app/services/platform-api.service';

@Component({
  selector: 'cw-ci-admin-reviwer-dashboard',
  templateUrl: './certification-dashboard.component.html',
  styleUrls: []
})
export class CertificationDashboardComponent implements OnInit {
  state;
  selectedAssessment:AccountAssessment;
  allowList = false;
  accountDetails;

  @Input() account:Account;
  @ViewChild(CertificationListComponent) assessmentList: CertificationListComponent;

  constructor(private _platformApi: PlatformApiService, private _activatedRoute: ActivatedRoute, private _router: Router) { }

  ngOnInit() {
    this.allowList = true;
    const accountDtls = localStorage.getItem('selectedCertificationAccount')
    if (accountDtls) {
      this.accountDetails = JSON.parse(accountDtls);
    }
    this._activatedRoute.params.subscribe(params => {
      const requestedAssessment = params.assessmentId;

      if (requestedAssessment) {
        this._platformApi.getCertificationAssmnt(requestedAssessment).subscribe(assessment => {
          this.selectedAssessment = assessment;
          if (this.selectedAssessment.status == 'COMPLETED') {
            this.state = 'ASSESSMENT_REPORT';
            this._platformApi.getAccount(this.selectedAssessment.accountId).subscribe(account => {
              this.account = account
            });
          }
        });
      } else {
        if (this.allowList) {
          this.state = 'LIST';
      }
    }
  });
  }

  showList() {
      console.log('this._activatedRoute',this._activatedRoute)
      localStorage.removeItem('selectedCertificationAccount');
      this._router.navigate(['../'], {relativeTo:this._activatedRoute});
  }

  onStateChange(event) {
    console.log('CertificationDashboardComponent.onStateChange:event', event);

    switch(event.state) {
      case 'ASSESSMENT_REPORT':
        this.state = 'ASSESSMENT_REPORT';
        this.selectedAssessment = event.accountAssessment;
        this.account = event.account;
        localStorage.setItem('selectedCertificationAccount',JSON.stringify(this.account));
        this._router.navigate([`${event.accountAssessment.id}`], {relativeTo: this._activatedRoute });
    }
  }

}
